import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Col, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Actions
import { get_depots, get_groups, get_regions, get_zones, set_area_filters } from '../../redux/actions/areasActions';
import { get_routes } from '../../redux/actions/routesActions';

const AreaFilters = (props) => {
	const { orgFilters, areaFilters, setAreaFilters } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const { regions, zones, depots, groups } = useSelector(state => state.areas);

	const onChangeAreaFilters = (e, name) => {
		const newFilters = { ...areaFilters };
		const keys = Object.keys(newFilters);
		const idx = keys.indexOf(name);

		if (e === undefined) {
			// Reset all filters from the selected index onward
			keys.slice(idx).forEach((key) => {
				newFilters[key] = '';
				localStorage.setItem(key, '');
			});
		}
		else {
			newFilters[name] = e.value;
			localStorage.setItem(name, e.value);
		}

		setAreaFilters(newFilters);
		dispatch(set_area_filters(newFilters));
	};

	const createFilters = (orgFilters, areaFilters) => {
		let filters = { organization: orgFilters.organization, workspace: orgFilters.workspace };

		for (const key in areaFilters) {
			if (areaFilters[key] !== '') {
				filters[key] = areaFilters[key];
			}
		}

		return filters;
	}

	useEffect(() => {
		if (orgFilters.organization !== '' && orgFilters.workspace !== '') {
			const filters = createFilters(orgFilters, areaFilters);

			dispatch(get_regions(filters));
			dispatch(get_zones(filters));
			dispatch(get_depots(filters));
			dispatch(get_groups(filters));
			dispatch(get_routes({ ...filters, module: orgFilters.module, skip: 0, limit: 10 }));
		}
	}, [orgFilters, areaFilters]);

	return (
		<Row justify='center' gutter={[16, 16]}>
			<Col className='gutter-row' style={{ zIndex: 10 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }}>
				<Row justify='center'>
					<Typography.Text>{t('filters.region')}</Typography.Text>
				</Row>
				<Select
					style={{ width: '100%' }}
					listHeight={160}
					options={regions.regions.map(option => ({ value: option._id.$oid, label: option.name }))}
					value={regions.regions.find(option => option._id.$oid === areaFilters.region)?.name}
					onChange={(value, option) => onChangeAreaFilters(option, 'region')}
					disabled={false}
					allowClear={true}
					showSearch
					filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())}
				/>
			</Col>
			<Col className='gutter-row' style={{ zIndex: 10 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }}>
				<Row justify='center'>
					<Typography.Text>{t('filters.zone')}</Typography.Text>
				</Row>
				<Select
					style={{ width: '100%' }}
					listHeight={160}
					options={zones.zones.map(option => ({ value: option._id.$oid, label: option.name }))}
					value={zones.zones.find(option => option._id.$oid === areaFilters.zone)?.name}
					onChange={(value, option) => onChangeAreaFilters(option, 'zone')}
					disabled={false}
					allowClear={true}
					showSearch
					filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())}
				/>
			</Col>
			<Col className='gutter-row' style={{ zIndex: 10 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }}>
				<Row justify='center'>
					<Typography.Text>{t('filters.depot')}</Typography.Text>
				</Row>
				<Select
					style={{ width: '100%' }}
					listHeight={160}
					options={depots.depots.map(option => ({ value: option._id.$oid, label: option.name }))}
					value={depots.depots.find(option => option._id.$oid === areaFilters.depot)?.name}
					onChange={(value, option) => onChangeAreaFilters(option, 'depot')}
					disabled={false}
					allowClear={true}
					showSearch
					filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())}
				/>
			</Col>
			<Col className='gutter-row' style={{ zIndex: 10 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }}>
				<Row justify='center'>
					<Typography.Text>{t('filters.group')}</Typography.Text>
				</Row>
				<Select
					style={{ width: '100%' }}
					listHeight={160}
					options={groups.groups.map(option => ({ value: option._id.$oid, label: option.name }))}
					value={groups.groups.find(option => option._id.$oid === areaFilters.group)?.name}
					onChange={(value, option) => onChangeAreaFilters(option, 'group')}
					disabled={false}
					allowClear={true}
					showSearch
					filterOption={(input, option) => (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())}
				/>
			</Col>
		</Row>
	);
}

AreaFilters.propTypes = {
	orgFilters: PropTypes.object.isRequired,
	areaFilters: PropTypes.object.isRequired,
	setAreaFilters: PropTypes.func.isRequired
};

export default AreaFilters;
